import React, { Component, useState, useEffect } from "react";
import { Multiselect } from "multiselect-react-dropdown";
import Switch from "react-switch";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import moment from "moment";
var FormData = require("form-data");

export default function Coupens() {
  const [coupenData, setCoupenData] = useState("");
  const [coupenName, setCoupenName] = useState("");
  const [coupenDate, setCoupenDate] = useState("");
  const [coupenTime, setCoupenTime] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [allCoupen, setAllCoupen] = useState(false);
  const [allUser, setAllUser] = useState(false);
  const [coupenDescription, setCoupenDescription] = useState("");
  const [discountType, setDiscountType] = useState("percentage");
  const [coupenMinimumAmount, setCoupenMinimumAmount] = useState("");
  const [coupenMaxDiscount, setCoupenMaxDiscount] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [image, setImage] = useState(null);
  const [keyImage, setKeyImage] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const [usageLimitCoupen, setUsageLimitCoupen] = useState(0);
  const [usageLimitUser, setUsageLimitUser] = useState(0);
  const objectArray1 = [
    {
      category: "Go_Movers",
      title: "Go Movers",
    },
    { category: "Go_Food", title: "Go Food" },
    // { category: "Grossary", },
    { category: "Go_Taxi", title: "Go Taxi" },
    { category: "Go_Grocery", title: "Go Grocery" },
    { category: "Go_Health", title: "Go Health" },
  ];
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const handleShow = () => {
    setCoupenName("");
    setIsActive(false);
    setCoupenDescription("");
    setCoupenMaxDiscount("");
    setCoupenDate("");
    setCoupenTime("");
    setDiscountType("percentage");
    setCoupenMinimumAmount("");
    setImageData(null);
    setUpdateStatus(false);
    setShow(true);
    setDeleteStatus(false);
    setUsageLimitCoupen(0);
    setUsageLimitUser(0);
    setAllCoupen(false);
    setAllUser(false);
    setDiscountAmount("");
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios.get(Baseurl.baseurl + `/health/get-coupon`).then((res) => {
      setSpinner(false);

      if (res.data.details) {
        setCoupenData(res.data.details);
      }
    });
  }
  function generateRandAlphaNumStr(len) {
    var rdmString = "";
    for (
      ;
      rdmString.length < len;
      rdmString += Math.random().toString(36).substr(2)
    );
    return rdmString.substr(0, len);
  }
  useEffect(() => {
    getData();
  }, []);
  const onChangePicture = (e) => {
    setImage(e.target.files[0]);
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImageData(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  function saveCoupen(e) {
    e.preventDefault();
    console.log("dates", coupenDate, coupenTime);
    var vals = coupenDate.split("-");
    var year = vals[0];
    var month = vals[1];
    var day = vals[2];
    var valTime = coupenTime.split(":");
    var hour = valTime[0];
    console.log("dates", year, month, day, hour);
    const data = new FormData();
    data.append("name", coupenName);
    data.append("description", coupenDescription);
    data.append("code", generateRandAlphaNumStr(12));
    data.append("discountType", discountType);
    data.append("amount", discountAmount);
    data.append("minSpent", coupenMinimumAmount);
    data.append("maxSpent", coupenMaxDiscount);
    data.append("category","Go_Health");
    data.append("image", image);
    data.append("year", year);
    data.append("month", month);
    data.append("day", day);
    data.append("hour", hour);
    data.append("allCoupon", allCoupen);
    data.append("usageLimitCoupon", usageLimitCoupen);
    data.append("allUser", allUser);
    data.append("usageLimitUser", usageLimitUser);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/health/add-coupon`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    handleClose();
  }
  function deleteCoupen(e) {
    e.preventDefault();
    axios
      .delete(Baseurl.baseurl + `/health/delete-coupon/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      });

    handleClose();
  }

  function updateCoupenImage(e) {
    e.preventDefault();
    if (image) {
      const data = new FormData();
      data.append("image", image);
      data.append("key", keyImage);
      var config = {
        method: "put",
        url: `${Baseurl.baseurl}/health/update-coupon-image/${bannerId}`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.status) {
            getData();
            setImage(null);
            setImageData(null);
            swal("Added", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      handleClose();
    } else {
      swal("Oops", "Choose file to update", "error", {
        button: "Done",
        timer: 1000,
      });
    }
  }

  function updateCoupenField(e) {
    e.preventDefault();
    console.log("dates", coupenDate, coupenTime);
    var vals = coupenDate.split("-");
    var year = vals[0];
    var month = vals[1];
    var day = vals[2];
    var valTime = coupenTime.split(":");
    var hour = valTime[0];
    let coupenData = {
      name: coupenName,
      description: coupenDescription,
      code: generateRandAlphaNumStr(12),
      discountType: `${discountType}`,
      minSpent: coupenMinimumAmount,
      maxSpent: coupenMaxDiscount,
      category: "Go_Health",
      active: isActive,
      year: year,
      month: month,
      day: day,
      hour: hour,
      allCoupon: allCoupen,
      usageLimitCoupon: usageLimitCoupen,
      allUser: allUser,
      usageLimitUser: usageLimitUser,
      amount: discountAmount,
    };
    axios
      .put(Baseurl.baseurl + `/health/update-coupon/${bannerId}`, coupenData)
      .then((response) => {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      });
    handleClose();
  }
  function setUpdateValues(val) {
    setDiscountType(val.DiscountType);
    setDiscountAmount(val.Amount);
    setCoupenName(val.Name);
    setIsActive(val.Active);
    setCoupenDescription(val.Description);
    setCoupenMaxDiscount(val.MaxSpent);
    setBannerId(val._id);
    setImageData(val.Image);
    setKeyImage(val.ImageKey);
    setCoupenMinimumAmount(val.MinSpent);
    setAllCoupen(val.AllCoupon);
    setAllUser(val.AllUser);
    setUsageLimitCoupen(val.UsageLimitCoupon);
    setUsageLimitUser(val.UsageLimitUser);
    const d = new Date(
      val.ExpDate.Year,
      val.ExpDate.Month - 1,
      val.ExpDate.Day
    );
    if (String(Math.abs(val.ExpDate.Hour)).length === 1) {
      setCoupenTime(`0${val.ExpDate.Hour}:00`);
    } else {
      setCoupenTime(`${val.ExpDate.Hour}:00`);
    }

    setCoupenDate(moment(d).format("YYYY-MM-DD"));
  }
  return (
    <Card
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {deleteStatus ? (
            <h4>
              Are you sure !! you want to delete Coupen
              <text className="text-danger">{coupenName}</text>
            </h4>
          ) : (
            <div className="card">
              <div className="card-body">
                <form
                  onSubmit={(e) => {
                    saveCoupen(e);
                  }}
                >
                  <div className="row">
                    <div className="col-sm-2 ">
                      <label>
                        Coupen Code<span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenName}
                        onChange={(e) =>{
                          if(!e.target.value.includes(" ")){
                            setCoupenName(e.target.value.toUpperCase())
                          }
                          
                        }
                          
                        }
                        placeholder="Enter Coupen Code"
                        required
                      />
                    </div>
                    <div className="col-sm-2">
                      <label>Coupen Description</label>
                    </div>
                    <div className="col-sm-4">
                      <textarea
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        rows={2}
                        value={coupenDescription}
                        onChange={(e) => setCoupenDescription(e.target.value)}
                        placeholder="Enter Coupen Description"
                      />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-sm-2">
                      <label>
                        Discount Type<span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <select
                        className="form-control"
                        id="val-skill"
                        name="val-skill"
                        required
                        defaultValue={discountType}
                        onChange={(event) => {
                          setDiscountType(event.target.value);
                        }}
                      >
                        <option selected="true" disabled="disabled"></option>
                        <option value="percentage">Percentage</option>
                        <option value="amount">Amount</option>
                      </select>
                    </div>
                    <div className="col-sm-2 ">
                      <label>
                        Discount{" "}
                        {discountType === "percentage"
                          ? "Percentage"
                          : "Amount"}
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={discountAmount}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => setDiscountAmount(e.target.value)}
                        placeholder={`Enter Discount ${
                          discountType === "percentage"
                            ? "Percentage"
                            : "Amount"
                        }`}
                      />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-sm-2">
                      <label>
                        Minimum Amount <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenMinimumAmount}
                        onChange={(e) => setCoupenMinimumAmount(e.target.value)}
                        placeholder="Enter Minimum Amount"
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="col-sm-2 mt-2">
                      <label>Max Discount</label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenMaxDiscount}
                        onChange={(e) => setCoupenMaxDiscount(e.target.value)}
                        placeholder="Enter Max Discount"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-sm-2 mt-2">
                      <label>Expiry Date</label>
                      <span className="text-danger">*</span>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        required
                        value={coupenDate}
                        onChange={(e) => {
                          setCoupenDate(e.target.value);
                        }}
                        placeholder="Enter Coupen Max Discount"
                      />
                    </div>
                    <div className="col-sm-2 mt-2">
                      <label>Expiry Time</label>
                      <span className="text-danger">*</span>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="time"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenTime}
                        onChange={(e) => {
                          setCoupenTime(e.target.value);
                        }}
                        placeholder="Enter"
                        required
                      />
                    </div>
                  </div>
                  {/* <div className="row mt-4">
                    <div className="col-sm-2 mt-2">
                      <label>Category</label>
                      <span className="text-danger">*</span>
                    </div>
                    <div className="col-sm-4">
                      <Multiselect
                        closeIcon="close"
                        options={objectArray1}
                        singleSelect
                        displayValue="title"
                        onSelect={selection2}
                        placeholder={updateStatus ? name : "Select Category"}
                      />
                    </div>
                  </div> */}
                  <div className="row mt-4">
                    <div className="col-sm-2 mt-2">
                      <label>All Coupen</label>
                    </div>
                    <div className="col-sm-4 mt-1">
                      <Switch
                        onColor="#135334"
                        onChange={() => {
                          setAllCoupen(!allCoupen);
                        }}
                        checked={allCoupen}
                      />
                    </div>
                    {!allCoupen && (
                      <>
                        <div className="col-sm-2 ">
                          <label>Usage limit Coupen</label>
                        </div>
                        <div className="col-sm-4">
                          <input
                            type="number"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={usageLimitCoupen}
                            onChange={(e) =>
                              setUsageLimitCoupen(e.target.value)
                            }
                            placeholder="Enter Usage limit Coupen"
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    <div className="col-sm-2 mt-2">
                      <label>All User</label>
                    </div>
                    <div className="col-sm-4 mt-1">
                      <Switch
                        onColor="#135334"
                        onChange={() => {
                          setAllUser(!allUser);
                        }}
                        checked={allUser}
                      />
                    </div>
                    {!allUser && (
                      <>
                        <div className="col-sm-2 ">
                          <label>Usage limit User</label>
                        </div>
                        <div className="col-sm-4">
                          <input
                            type="number"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={usageLimitUser}
                            onChange={(e) => setUsageLimitUser(e.target.value)}
                            placeholder="Enter Usage limit User"
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {updateStatus && (
                    <div className="row mt-4">
                      <div className="col-sm-2 mt-2">
                        <label>Is Active</label>
                      </div>
                      <div className="col-sm-4 mt-1">
                        <Switch
                          onColor="#135334"
                          onChange={() => {
                            setIsActive(!isActive);
                          }}
                          checked={isActive}
                        />
                      </div>
                    </div>
                  )}
                  {updateStatus && (
                    <div className="row">
                      <div>
                        <Button
                          className="mt-3"
                          variant="primary"
                          onClick={(e) => {
                            updateCoupenField(e);
                          }}
                        >
                          Update
                        </Button>
                      </div>
                    </div>
                  )}
                  <div className="row mt-4">
                    <div className="col-sm-2 mt-2">
                      <label>
                        Coupen Image<span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <div className="register_profile_image mt-2">
                        <input
                          id="profilePic"
                          type="file"
                          onChange={(e) => {
                            onChangePicture(e);
                          }}
                        />
                      </div>
                      {imageData && (
                        <div
                          style={{
                            marginTop: "5px",
                            width: 180,
                            height: 100,
                            aspectRatio: 1 * 1.4,
                          }}
                          className="previewProfilePic"
                        >
                          <img
                            className="playerProfilePic_home_tile"
                            style={{
                              resizeMode: "cover",
                              width: "100%",
                              height: "100%",
                            }}
                            src={imageData}
                          />
                        </div>
                      )}
                    </div>
                    {updateStatus && (
                      <div className="col-sm-2 mt-2">
                        <Button
                          className="mt-5"
                          variant="primary"
                          onClick={(e) => {
                            updateCoupenImage(e);
                          }}
                        >
                          Update
                        </Button>
                      </div>
                    )}
                  </div>
                  {updateStatus ? null : (
                    <div>
                      <input
                        className="btn btn-primary mt-4"
                        type="submit"
                        value="submit"
                      />
                    </div>
                  )}
                </form>
              </div>
            </div>
          )}
        </Modal.Body>

        {deleteStatus && (
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={(e) => {
                deleteCoupen(e);
              }}
            >
              Delete
            </Button>
          </Modal.Footer>
        )}
      </Modal>
      <div>
        <div style={{ padding: 20 }} className="flex-container">
          <div>
            <div>
              <button
                className="btn btn-primary float-right"
                onClick={handleShow}
              >
                Add Coupen
              </button>
            </div>
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive className="text-white">
                <thead>
                  <tr>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Description</strong>
                    </th>
                    <th>
                      <strong>Code</strong>
                    </th>
                    <th>
                      <strong>Minimum Amount</strong>
                    </th>
                    {/* <th>
                      <strong>Condition Amount</strong>
                    </th> */}
                    <th>
                      <strong>Max Discount</strong>
                    </th>
                    <th>
                      <strong>Usage Limit Coupen</strong>
                    </th>
                    <th>
                      <strong>Usage Limit User</strong>
                    </th>
                    <th>
                      <strong>Expiry Date</strong>
                    </th>
                    {/* <th>
                      <strong>Category</strong>
                    </th> */}
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {coupenData &&
                    coupenData.map((val) => (
                      <tr>
                        <td>{val.Name}</td>
                        <td>{val.Description}</td>
                        <td>{val.Code}</td>
                        <td>{val.MinSpent}</td>
                        {/* <td>{val.ConditionAmount}</td> */}
                        <td>{val.MaxSpent}</td>
                        <td>{val.UsageLimitCoupon}</td>
                        <td>{val.UsageLimitUser}</td>
                        <td>
                          {val.ExpDate.Day}/{val.ExpDate.Month}/
                          {val.ExpDate.Year} Time {val.ExpDate.Hour}:00
                        </td>
                        {/* <td>{val.Category}</td> */}
                        <td>
                          <div
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                            className="col-sm-12"
                          >
                            <img
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              class="img-fluid"
                              alt="Responsive image"
                              src={val.Image}
                            />
                          </div>
                        </td>
                        <td>{val.Active ? "Active" : "Inactive"}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setUpdateValues(val);
                                  setUpdateStatus(true);
                                  setDeleteStatus(false);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setCoupenName(val.Name);
                                  setDeleteStatus(true);
                                  setShow(true);
                                  setBannerId(val._id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            <>
              {!coupenData && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Add Coupens
                </Alert>
              )}
            </>
          </div>
        </div>
      </div>
    </Card>
  );
}
